(function () {
    function rivieraSite(p) {
        var _site = {};
        var menu = $(p.menu);
        var footer = $(p.footer)
        var _arr = _arr || [];

        get_scroll_bar_width = function () {
            var inner = document.createElement('p');
            inner.style.width = "100%";
            inner.style.height = "200px";

            var outer = document.createElement('div');
            outer.style.position = "absolute";
            outer.style.top = "0px";
            outer.style.left = "0px";
            outer.style.visibility = "hidden";
            outer.style.width = "200px";
            outer.style.height = "150px";
            outer.style.overflow = "hidden";
            outer.appendChild(inner);

            document.body.appendChild(outer);
            var w1 = inner.offsetWidth;
            outer.style.overflow = 'scroll';
            var w2 = inner.offsetWidth;
            if (w1 == w2) w2 = outer.clientWidth;

            document.body.removeChild(outer);

            return (w1 - w2);
        }

	_site.changeMenuRealtyType = function(type) {
		$('#all_offers').attr("href","/"+type+"/french-riviera/");
		$('.menu_realty_types').hide();
		$('#menu_realty_type_'+type).show();


        $('.menu_custom_realty_types').hide();
        $('#menu_custom_realty_type_'+type).show();
	}

	$('.offers-filter li a').click(function(ev, el) {
		$(this).parent().parent().find('li').removeClass("active");
		$(this).parent().addClass("active");
		$.get('/fresh-offers/results/?type='+$(this).attr('type'), function (data) {
			$('#fresh_offers_data').fadeOut('slow',function() {
			    //id ( data.length < 10  ) {
                //}
				$('#fresh_offers_data').html(data);
				$('#fresh_offers_data').fadeIn('slow');
			});
		});

	});



        _site.digist_separate = function (selector) {
            $(selector).number(true, 0, ',', ' ');
        };

        _site.init_intro_video = function (params) {
            if (window.innerWidth < 770) {
                return true;
            }
            $(params.dom_id).YTPlayer({
                fitToBackground: true,
                videoId: params.video_id,
                mute: true,
                loop: false,
                vol: 1
            });
        }

	    //!!!!!!!!!!!!!!!!
        _site.scroll_to = function (selector) {
            $('body').on('click', selector, function (event) {
                event.preventDefault();
                var targetID = $(this).data('scroll');
                var targetEl = $('[data-scroll-target="' + targetID + '"]');
                if (targetEl.length) {
                    var h = targetEl.offset().top;
                    if ($('body').hasClass('fixed-nav')) {
                        h = h - menu.height();
                    }
                    $('html, body').stop().animate({scrollTop: h}, 800);
                }
            });
        }

        _site.home_page_nav = function () {
            if (window.innerWidth > 770) {
                menu.find('.navbar').removeClass('navbar-default').addClass('navbar-opacity');
                _site.home_page = true;
            }
            window.addEventListener('resize', function () {
                if (window.innerWidth < 770 && menu.find('.navbar').hasClass('navbar-opacity')) {
                    menu.find('.navbar').removeClass('navbar-opacity').addClass('navbar-default');
                } else {
                    if (window.scrollY === 0)
                        menu.find('.navbar').removeClass('navbar-default').addClass('navbar-opacity');
                }
            }, false);
        }

        _site.sticky_nav = function (p) {
            var pt = parseInt($(p.point).css('padding-top'));

            function toggleNav() {
                menu.find('[data-menu="toggle"]').removeClass('is-active');
                menu.find('.navbar-submenu').removeClass('is-active');
                _arr = [];
            }

            function on_down() {
                menu.addClass('is-fixed');
                menu.find('.navbar').addClass('navbar-default').removeClass('navbar-opacity');
                $('.home-intro-pseudo').css('margin-top', -parseInt($('#navigation').height()) + 'px');
                $(p.point).css({'padding-top': menu[0].scrollHeight + pt + 'px'});
                window.menu_disable = true;
            }

            function on_up() {
                menu.toggleClass('is-fixed');
                $('.home-intro-pseudo').css('margin-top', -parseInt($('#navigation').height()) + 'px');
                if (window.innerWidth > 770) {
                    menu.find('.navbar').removeClass('navbar-default').addClass('navbar-opacity');
                }
                window.menu_disable = false;
                $(p.point).css({'padding-top': pt + 'px'});
            }

            if ($(p.point).length) {
                var waypoint = new Waypoint({
                    element: $(p.point)[0],
                    handler: function (direction) {
                        toggleNav();
                        direction == 'down' ? on_down() : on_up();
                    }
                });
            }
        }

        _site.toggle_menu = function (p) {
            menu.find('[data-menu="toggle"]').click(function (event) {
                event.preventDefault();
                // get menu id
                var menuID = $(this).attr('href').split('#').pop();
                _arr.push(menuID);


                if (_arr[_arr.length - 2] == menuID) {
                    menu.find('.navbar-submenu').removeClass('is-active');
                    menu.find('[data-menu="toggle"]').removeClass('is-active');
                    _arr = [];

                } else {
                    menu.find('[data-menu="toggle"]').removeClass('is-active');
                    $(this).addClass('is-active');
                    menu.find('.navbar-submenu').removeClass('is-active').filter('[data-id="' + menuID + '"]').addClass('is-active');
                    if (window.innerWidth < 770) {
                        menu.find('.navbar-submenu').filter('[data-id="' + menuID + '"]').css({
                            'margin-top': parseInt((this.scrollHeight * ( $(this).parent().index() + 1)) + (($(this).parent().index() + 1) * 2)) + 'px'
                        });
                    }
                }

                $('#bs-example-navbar-collapse-1').on('hide.bs.collapse', function () {
                    menu.find('.navbar-submenu').removeClass('is-active');
                    menu.find('[data-menu="toggle"]').removeClass('is-active');
                    _arr = [];
                })
            });
        }

        $('#bs-example-navbar-collapse-1').on('shown.bs.collapse', function () {
            if (!$('#navigation').hasClass('is-fixed')) {
                $('.home-intro-pseudo').css('margin-top', -parseInt($('#navigation').height()) + 'px');
            }
        }).on('hide.bs.collapse	', function () {
            if (!$('#navigation').hasClass('is-fixed')) {
                $('.home-intro-pseudo').css('margin-top', -80 + 'px');
            }
        });

        _site.footer_form = function () {
            var _t = {};
            var modal = footer.find('.footer-callback-modal');
            var form = modal.find('form');
            var success_message = modal.find('.form-sended');

            form.find('[type="submit"]').click(function (event) {
                form.addClass('form-submitted')
            });
            form.submit(function (event) {
                event.preventDefault();
                if (!event.target.checkValidity()) // hack for safari browser, because it not support required argument
                    return false;
                success_message.show();
                form.hide();
            });

            function disable_scroll(e) {
                if (e.target.id == 'el') return;
                e.preventDefault();
                e.stopPropagation();
            }

            _t.show = function () {
                $('.page-top-bar, .static-page-scroll-top').css({'z-index': '0'});
                $('.page-top-bar').removeClass('is-visible');
                footer.addClass('show-modal');
                menu.css({'z-index': '11'});
                $('body').on({'mousewheel': disable_scroll, 'touchmove': disable_scroll});
            }
            _t.hide = function () {
                footer.removeClass('show-modal');
                form.removeClass('form-submitted').show().trigger('reset');
                success_message.hide();
                menu.css({'z-index': '1020'});
                $('.page-top-bar, .static-page-scroll-top').css({'z-index': '800'});
                $('body').off('mousewheel').off('touchmove');
            }

            return _t;
        }

        _site.request_modal_form = function () {
            var _t = {};

            var modal = footer.find('.footer-request-modal');
            var form = modal.find('form');

            function disable_scroll(e) {
                if (e.target.id == 'el') return;
                e.preventDefault();
                e.stopPropagation();
            }

            _t.show = function () {
                $('.page-top-bar, .static-page-scroll-top').css({'z-index': '0'});
                $('.page-top-bar').removeClass('is-visible');
                footer.addClass('show-request-modal');
                menu.css({'z-index': '11'});
                $('body').on({'mousewheel': disable_scroll, 'touchmove': disable_scroll});
            }
            _t.hide = function () {
                footer.removeClass('show-request-modal');
                form.removeClass('form-submitted').show().trigger('reset');
                form.css('display', 'block');
                menu.css({'z-index': '1020'});
                $('.page-top-bar, .static-page-scroll-top').css({'z-index': '800'});
                $('body').off('mousewheel').off('touchmove');
            }

            return _t;
        }

        _site.main_cat_id = [];
        _site.set_main_cat_id = function (id, type) {
            _site.main_cat_id[type] = id;
        }

        _site.get_main_cat_id = function (_type) {

            if ( _type.match(/commercial/) )
                return _site.main_cat_id['commercial'];
            else if ( _type.match(/region/) )
                return _site.main_cat_id['region'];
        }

        _site.expand_search = function () {
            var baseClass = '.search-expand';
            var btn = $(baseClass + '-btn');
            var more = $(baseClass + '-more');
            var def = $(baseClass + '-def');

            btn.click(function (e) {
                def.find('.btn-1').toggle();
                def.find('.btn-1').parent().prev().toggleClass('col-xs-9').toggleClass('col-xs-12');
                more.toggle();
            });
        };

        _site.toggle_favorite_obj = function (el) {

            var d_a = $(el).attr('data-add');
            var d_r = $(el).attr('data-remove');

            var nt = $(el).attr('data-title');
            var ref = $(el).attr('data-ref');
            var ct = $('#tip-item').text();



            $(el).attr({
                'data-favorite': ($(el).attr('data-favorite') != 'true') ? true : false,
                'data-title': ($(el).attr('data-favorite') != 'true') ? d_a: d_r,
                //'title': ($(el).attr('data-favorite') != 'true') ? d_r : d_a,
            });


            if (  ($(el).attr('data-favorite') == 'true') )
                $(el).find('.fa').removeClass('fa-heart-o').addClass('fa-heart');
            else
                $(el).find('.fa').removeClass('fa-heart').addClass('fa-heart-o');
            //if ($(el).find('.fa-heart-o').length || $(el).find('.fa-heart').length) {
            //    $(el).find('.fa').toggleClass('fa-heart-o fa-heart');
            //}


            if ($(el).hasClass('is-text')) {
                $(el).find('.text-wrap').text( ($(el).attr('data-favorite') != 'true') ? d_a : d_r );
            }



            var favObjects = localStorage.getItem("favourites");
            if ( favObjects != "" )
                favObjects = JSON.parse(favObjects);
            if ( favObjects == null || typeof(favObjects) != "object" ) favObjects = {};
            favObjects[ref] = ($(el).attr('data-favorite') == 'true') ? 1 : 0;
            //if ( favObjects[ref] == 0 ) delete favObjects[ref];
            localStorage.setItem("favourites", JSON.stringify(favObjects));
            console.log(favObjects);


            var found = false;
            for(ref in favObjects) { if ( favObjects[ref] ) { found=true; } }
            if ( found )  _site.show_favs_link();
            else  _site.hide_favs_link();



            //$('#tip-item').text( ($(el).attr('data-favorite') != 'true') ? d_a : d_r );
            $(el).data('powertip', ($(el).attr('data-favorite') != 'true') ? d_a : d_r );
        }

        _site.load_fav_objects = function (el) {
            var d_a = $(el).attr('data-add');
            var d_r = $(el).attr('data-remove');
            var nt = $(el).attr('data-title');
            var ref = $(el).attr('data-ref');
            var ct = $('#tip-item').text();

            var favObjects = localStorage.getItem("favourites");
            if ( favObjects != "" )
                favObjects = JSON.parse(favObjects);
            if ( favObjects == null || typeof(favObjects) != "object" ) favObjects = {};

            if ( favObjects[ref] == 1 )
                _site.show_favs_link();


            console.log(favObjects);
            console.log(favObjects[ref]);

            $(el).attr({
                'data-favorite': (favObjects[ref] == 1) ? true : false,
                'data-title': (favObjects[ref] == 1) ? d_r : d_a
            });


            if (  ($(el).attr('data-favorite') == 'true') )
                $(el).find('.fa').removeClass('fa-heart-o').addClass('fa-heart');
            else
                $(el).find('.fa').removeClass('fa-heart').addClass('fa-heart-o');
            //if ($(el).find('.fa-heart-o').length || $(el).find('.fa-heart').length) {
            //    $(el).find('.fa').toggleClass('fa-heart-o fa-heart');
            //}

            if ($(el).hasClass('is-text')) {
                $(el).find('.text-wrap').text((favObjects[ref] == 1) ? d_r : d_a);
            }


            //$('#tip-item').text( (favObjects[ref] == 1) ? d_r : d_a);
            $(el).data('powertip', (favObjects[ref] == 1) ? d_r : d_a );
        }

        _site.show_favs_link = function ()
        {
            $('.is-favorite').show();
            $('.is-favorite').click(function() {
                return;
                console.log(111);
                var favObjects = localStorage.getItem("favourites");
                if ( favObjects != "" )
                    favObjects = JSON.parse(favObjects);
                if ( favObjects == null || typeof(favObjects) != "object" ) favObjects = {};

                var refs="";
                for(ref in favObjects) { if ( favObjects[ref] ) { refs+=ref+":"; } }
                refs = refs.replace(/:$/g,'');
                document.location = $('.is-favorite').attr('data-lang') + '/favorites/' + "?refs=" + refs;
            })
        }
        _site.hide_favs_link = function ()
        {
            $('.is-favorite').hide();
        }

        _site.fav_check_link = function ()
        {
            var favObjects = localStorage.getItem("favourites");
            if ( favObjects != "" )
                favObjects = JSON.parse(favObjects);
            if ( favObjects == null || typeof(favObjects) != "object" ) {
                $('.is-favorite').hide();
            } else {
                $('.is-favorite').show();
            }

        }




        _site.consultation_form = function (container) {
            var c = $(container);
            var form = c.find('form');
            var success_message = c.find('.form-sended');

            var waitForFinalEvent = (function () {
                var timers = {};
                return function (callback, ms, uniqueId) {
                    if (!uniqueId) {
                        uniqueId = "Don't call this twice without a uniqueId";
                    }
                    if (timers[uniqueId]) {
                        clearTimeout(timers[uniqueId]);
                    }
                    timers[uniqueId] = setTimeout(callback, ms);
                };
            })();

            // fix height of container
            setTimeout(function () {
                $.each(c, function (i, el) {
                    if (!$(el).hasClass('dynamic')) {
                        $(el).css('height', $(el).css('height'));
                    }
                });
            }, 2000);

            $(window).resize(function () {
                waitForFinalEvent(function () {
                    c.css('height', 'auto');
                    $.each(c, function (i, el) {
                        if (!$(el).hasClass('dynamic')) {
                            $(el).css('height', $(el).css('height'));
                        }
                    });
                }, 500, "some unique string");
            });


            form.find('[type="submit"]').click(function (event) {
                c = $(this).parents(container).eq(0);
                form = c.find('form');
                success_message = c.find('.form-sended');
                form.addClass('form-submitted');
            });
            form.submit(function (event) {
                event.preventDefault();
                if (!event.target.checkValidity()) // hack for safari browser, because it not support required argument
                    return false;
                success_message.show();
                form.hide();


                if (c.parents('#topbar-second').length) {
                    setTimeout(function () {
                        $('#topbar-second').collapse('hide');
                    }, 3000);
                }


                if (c.hasClass('autoshow')) {
                    setTimeout(function () {
                        success_message.hide();
                        form.show().removeClass('form-submitted')[0].reset();
                    }, 3000);
                }
            });

        }



        $( ".feedback_form" ).on( "submit", function( event ) {
            //event.preventDefault();
            data = $( this ).serialize();
            $.post('/feedback/create/', data, function(data){}, 'json').error(function(data){});
        });


        $( ".subscribe-form" ).on( "submit", function( event ) {
            //event.preventDefault();
            data = $( this ).serialize();
            $.post('/feedback/subscribe/', data, function(data){}, 'json').error(function(data){});
        });





        _site.object_change_price = function (el) {
            var container = $(el).parents('.table-cell-view');
            var ct = container.find('.item-title b').html();
            var cp = container.find('.item-value b').html();

            container.find('.item-title b').html(container.find('.item-title').data('alt')).parent().data('alt', ct);
            container.find('.item-value b').html(container.find('.item-value').data('alt')).parent().data('alt', cp);
        }


        _site.init_obj_map = function (id) {
            var el = document.getElementById(id);
            if (!el) {
                return;
            }
            map = new google.maps.Map(el, {
                zoom: parseInt(el.dataset.zoom) || 13,
                center: new google.maps.LatLng(el.dataset.lat, el.dataset.lng),
                scrollwheel: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_CENTER
                },
            });

            if (el.dataset.marker) {
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(el.dataset.lat, el.dataset.lng)
                });
                marker.setMap(map);
            }
        }

        _site.tips = function () {
            $(p.tipsSelector).powerTip({
                followMouse: true,
                popupId: 'tip-item',
                offset: 5
            });
        }
        var sliderObj = null;
        _site.object_slider_init = function (selector, params) {
            params.responsive = [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        // swipe:true,
                        cssEase: 'linear',
                        speed: 300,
                        centerMode: false,
                        // fade:true,
                        // swipeToSlide:true,
                        // useCSS:false,
                        // easing:'false'
                        // dots: false
                    }
                }
            ]
            sliderObj = $(selector[0]).slick(params);
            var sl = new Hammer($(selector[0]).eq(0)[0]);
            sl.on('swipeleft', function () {
                sliderObj.slick('slickNext');
            }).on('swiperight', function () {
                sliderObj.slick('slickPrev');
            });
            function positionArrows() {
                $(selector[1]).css({right: parseInt($('.container-fluid').offset().left) + 15 + 'px'});
                $(selector[2]).css({left: parseInt($('.container-fluid').offset().left) + 15 + 'px'});
            };
            $(window).on('resize', positionArrows);
            positionArrows();
        }


        _site.top_bar = function (selector) {
            var lastScrollTop = 0;
            $(window).scroll(function (event) {
                var st = $(this).scrollTop();
                if (st < lastScrollTop) {
                    if ((lastScrollTop < 110 || lastScrollTop == 0)) {
                        $(selector).removeClass('is-visible')
                    } else {
                        if ((st - lastScrollTop) < -1 && !$(selector).hasClass('is-visible')) {

                            setTimeout(function () {
                                if (lastScrollTop != 0) {
                                    $(selector).addClass('is-visible');
                                }
                            }, 300);
                        }

                    }
                } else {
                    $(selector).removeClass('is-visible');
                }
                lastScrollTop = st;
            });
        }

        _site.image_gallery = function (container, selector) {
            function disable_scroll(e) {
                if (e.target.id == 'el') return;
                e.preventDefault();
                e.stopPropagation();
            }

url = document.location.href;

            $(container).magnificPopup({
                delegate: selector, // child items selector, by clicking on it popup will open
                type: 'image',
                removalDelay: 300,

                // Class that is added to popup wrapper and background
                // make it unique to apply your CSS animations just to this exact popup
                mainClass: 'mfp-fade',
                callbacks: {
                    open: function () {
                        $('body').on({'mousewheel': disable_scroll, 'touchmove': disable_scroll});
                        mc.on("swipeleft", nextImg);
                        mc.on("swiperight", prevImg);
                    },
                    close: function () {
                        $('body').off('mousewheel').off('touchmove');
                        mc.off("swipeleft", nextImg);
                        mc.off("swiperight", prevImg);
                    },
                    change: function () {
                        if (sliderObj) {
                            sliderObj.slick('slickGoTo', magnificPopup.index, true);
                        }
                        if (newsSlider) {
                            newsSlider.goToSlide(magnificPopup.index);
                        }
                    },
                },
                gallery: {
                    enabled: true
                },
                image: {
                    markup: '<div class="mfp-figure">' +
                    '<div class="container-fluid">' +
                    '<div class="mfp-top-bar"><div class="clearfix">' +
                    '<div class="col-mobile-2"><span class="mfp-counter"></span></div>' +
                    '<div class="col-mobile-8 mfp-author-wrap"><i class="ri ri-photo"></i><span class="mfp-author"></span></div>' +
                    '<div class="col-mobile-2 text-right"><div class="mfp-close"></div></div>' +
                    '</div></div>' +
                    '</div>' +
                    '<div class="container-fluid img-container">' +
                    '<div class="inner">' +
                    '<div class="mfp-img"></div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="mfp-bottom-bar">' +
                    '<div class="container-fluid">' +
                    '<div class="row">' +
                    '<div class="col-md-10 col-mobile-7">' +
                    '<div class="mfp-title"></div>' +
                    '</div>' +
                    '<div class="col-md-2 col-mobile-5 text-right">' +
                    '<div class="ssk-group">' +
                    '<a href="javascript:openShareDialog(\'https://www.facebook.com/sharer/sharer.php?u='+url+'\')" class="ssk ssk-xs ssk-facebook"></a>' +
                    '<a href="javascript:openShareDialog(\'https://plus.google.com/share?url='+url+'\')" class="ssk ssk-xs ssk-google-plus"></a>' +
                    '<a href="javascript:openShareDialog(\'http://twitter.com/share?url='+url+'\')" class="ssk ssk-xs ssk-twitter"></a>' +
//                  '<a href="#" class="ssk ssk-xs ssk-vk"></a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                }
                // other options
            });
            var magnificPopup = $.magnificPopup.instance;

            function nextImg() {
                magnificPopup.next();
            }

            function prevImg() {
                magnificPopup.prev();
            }

            var mc = new Hammer(document.body);
        }

        _site.object_map_parallax = function (selector) {
            var container = $(selector);
            var lst = 0;
            var h = container.offset().top - parseInt(container.css('height'));
            var end = container.offset().top + parseInt(container.css('height'));


            var i = 0;
            $(window).scroll(function (event) {
                var st = $(this).scrollTop();

                if (st > lst) {
                    if (container.offset().top < st && end > st) {
                        i++;
                        container.find('.map').css({'transform': 'translateY(' + (i) + 'px)'});
                    }
                } else {
                    if (container.offset().top < st && end > st) {
                        i--;
                        container.find('.map').css({'transform': 'translateY(' + (i) + 'px)'});
                    }
                }
                lst = st;
            });
        }

        _site.scoll_top_btn = function (selector) {
            $(window).scroll(function (event) {
                $(this).scrollTop() > 80 ? $(selector).addClass('is-visible') : $(selector).removeClass('is-visible');
            });
        }

        var newsSlider = null;
        _site.news_slider = function () {

            newsSlider = $(".newsImages").lightSlider({
                item: 1,
                slideMargin: 0,
                thumbItem: 8,
                gallery: true,
                addClass: 'page-slider',
                controls: false,
                pager: true,
                adaptiveHeight: false,
                thumbMargin: 10,
                enableTouch: true,
                enableDrag: true,
                responsive: [
                    {
                        breakpoint: 960,
                        settings: {
                            thumbItem: 5
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            gallery: false
                        }
                    }
                ],
                onSliderLoad: function (el) {
                    var s = el;
                    var tl = window.innerWidth > 768 ? 8 : 5;

                    $('.news-article-slider-btns .arrow.next').on('click', function (e) {
                        s.goToNextSlide();
                    });
                    $('.news-article-slider-btns .arrow.prev').on('click', function (e) {
                        s.goToPrevSlide();
                    });


                    
                    (function () {
                        var thumbsWrap = $('.lSPager.lSGallery')[0];
                        if (!thumbsWrap) {
                            return false;
                        }
                        var thumbsNodes = thumbsWrap.childNodes;
                        var thumbWidth = thumbsNodes[0].offsetWidth;


                        if (el.parents('.news-article-slider').width() < $(thumbsWrap).width()) {
                            var dotsLength = Math.ceil($(thumbsWrap).width() / el.parents('.news-article-slider').width());

                            for (var i = 0; i < dotsLength; i++) {
                                var cl = i == 0 ? 'active' : '';
                                $('.news-article-slider_dots').append('<div class="owl-dot ' + cl + '" data-index="' + (i) + '"></div>');
                            }
                            ;

                            $('.news-article-slider_dots .owl-dot').on('click', function (e) {
                                if ($(this).data('index') > 0) {
                                    // var w = el.parents('.news-article-slider').find('.lSSlideWrapper').width()  * ($(this).data('index'));
                                    var w = (tl * (parseInt($('.news-article-slider .lSPager.lSGallery li').css('width')) + parseInt($('.news-article-slider .lSPager.lSGallery li').css('margin-right')))) * $(this).data('index');
                                } else {
                                    w = 0;
                                }

                                $('.lSSlideOuter .lSPager.lSGallery').css({
                                    'transform': 'translate3d(-' + w + 'px, 0px, 0px)'
                                });
                                $('.news-article-slider_dots .owl-dot').removeClass('active');
                                $(this).addClass('active');
                            });

                        }

                        (function () {
                            var tc = new Hammer(thumbsWrap);
                            var dots = $('.news-article-slider_dots .owl-dot');
                            tc.on('swipeleft', function () {
                                if (dots.filter('.active').index() + 1 < dots.length)
                                    dots.eq(dots.filter('.active').index() + 1).click();
                            }).on('swiperight', function () {
                                if (dots.filter('.active').index() !== 0)
                                    dots.eq(dots.filter('.active').index() - 1).click();
                            });
                        }());

                    }());

                },
                onAfterSlide: function (el) {
                    var actInd = $(el).find('.active').index();
                    var thumbsNodes = $('.lSPager.lSGallery')[0].childNodes;
                    var dots = $('.news-article-slider_dots .owl-dot');
                    var inview = Math.floor(thumbsNodes.length / dots.length);
                    var dotIdex = ((Math.floor(actInd / inview) ) > 0) ? (Math.floor(actInd / inview) ) : 0;

                    if (dots.length != dotIdex) {
                        $('.news-article-slider_dots .owl-dot').removeClass('active').eq(dotIdex).addClass('active');
                    }
                }
            });
        }

        if (window.innerWidth < 1025) {
            function setCutBreadcrumbs() {
                var bc = $('.breadcrumb'),
                    bcItems = bc.find('>*'),
                    bcLast = bcItems.eq(bcItems.length - 1),
                    bcContainerWidth = parseInt(bc.width()),
                    bcItemsWidth = 0;
                bcItems.each(function (i, el) {
                    bcItemsWidth += parseInt($(el).width());
                });
                if (bcContainerWidth < bcItemsWidth && window.innerWidth > 750)
                    bcLast.css('max-width', (bcContainerWidth - (bcItemsWidth - bcLast.width()) - 20) + 'px');
                else if (bcContainerWidth > bcItemsWidth && bcLast[0].style.maxWidth) {
                    bcLast[0].style.maxWidth = '';
                }
            }

            setCutBreadcrumbs();
            window.addEventListener('resize', setCutBreadcrumbs, false);
        }

        _site.toggle_menu();
        if (window.innerWidth > 1025) {
            _site.tips();
        }
        _site.scroll_to(p.scrollToSelector);
        return _site;
    };

    window.site = new rivieraSite({
        menu: '#navigation',
        footer: '.footer',
        tipsSelector: '.tips',
        scrollToSelector: '.scroll-to'
    });
}());


(function () {
    $('a[data-href]').click(function (e) {
        e.preventDefault();

        document.location=e.currentTarget.getAttribute('data-href');
        //window.open(e.currentTarget.getAttribute('data-href'));
    });
}());
